import React, {useCallback, useContext, useState} from "react";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";
import Loader from "@amzn/meridian/loader";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Button from "@amzn/meridian/button";
import {FormattedMessage} from "react-intl";
import {LabelSheetResponse} from "./LabelSheetResponse";
import {PrintLabelContext} from "./context/PrintLabelContext";
import {PrintLabelSheetActions} from "./actions/PrintLabelSheetActions";

/* Shows a dialog box to take confirmation
*  and then inflates result
* */
export const PrintLabelSheetDialog = ({isModalOpen, onModelOpenChange, trackingIds}) => {
    const {printLabelModel, printLabelDispatch} = useContext(PrintLabelContext);
    const [isCASProcessOngoing, setCASProcessOngoing] = useState(false);

    function resetRequestParamters() {
        setCASProcessOngoing(false);
        onModelOpenChange(false);
        printLabelDispatch({
            type: PrintLabelSheetActions.RESET_REQUEST
        });
    }

    const closeModal = useCallback(() => {resetRequestParamters()}, []);

    return (
        <Modal
            title={<FormattedMessage id="print.label_sheet" defaultMessage="Get Label Sheet"/>}
            open={isModalOpen}
            onClose={closeModal}
            scrollContainer="viewport"
            closeLabel="Close"
            width={500}>
            <Box height={100}>
                {!printLabelModel.isLoading && !printLabelModel.requestCompleted && !isCASProcessOngoing &&
                <Box>
                    <Text type="h100"><FormattedMessage id="print.label_sheet_confirmation"
                                                        defaultMessage="Click Confirm to get label sheet"/></Text>
                    <br/>
                    <ModalFooter>
                        <Row spacingInset="small" alignmentHorizontal="right" widths="fit">
                            <Button type="secondary" size="small" onClick={closeModal}>
                                Cancel
                            </Button>
                            <Button type="primary" size="small" onClick={() => setCASProcessOngoing(true)}>
                                Confirm
                            </Button>
                        </Row>
                    </ModalFooter>
                </Box>
                }
                {!printLabelModel.isLoading && printLabelModel.requestCompleted &&
                !printLabelModel.errorOccurred && isCASProcessOngoing && closeModal()}

                { printLabelModel.isLoading && !printLabelModel.requestCompleted &&
                <Row alignmentHorizontal="center" alignmentVertical="center" height="100%">
                    <Loader type="circular"/>
                    <Text type="h200"><FormattedMessage id="print.label_sheet_loading"
                                                        defaultMessage="Generating label sheet"/></Text>
                </Row>
                }

                {isCASProcessOngoing &&
                <LabelSheetResponse trackingIds={trackingIds}  targetStation={printLabelModel.targetStation}/>}
            </Box>
        </Modal>
    );
};



// WEBPACK FOOTER //
// ./src/components/labelSheet/PrintLabelSheetDialog.js